/**
 * Validation utilities for MembersScreen
 */

export const validateEmail = (email) => {
  if (!email || email.trim() === "") return { isValid: true, error: "" };

  const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
  if (!emailPattern.test(email)) {
    return { isValid: false, error: "Enter a valid email address." };
  }
  return { isValid: true, error: "" };
};

export const validateMobile = (mobile) => {
  if (!mobile || mobile.trim() === "") return { isValid: true, error: "" };

  const mobilePattern = /^[0-9]{10}$/;
  if (!mobilePattern.test(mobile)) {
    return { isValid: false, error: "Enter valid mobile no." };
  }
  return { isValid: true, error: "" };
};

export const validateHome = (home) => {
  if (!home || home.trim() === "") return { isValid: true, error: "" };

  const homePattern = /^[0-9]{10}$/;
  if (!homePattern.test(home)) {
    return { isValid: false, error: "Enter valid home no." };
  }
  return { isValid: true, error: "" };
};

export const validateSin4 = (sin4) => {
  if (!sin4 || sin4.trim() === "") return { isValid: true, error: "" };

  const sin4Pattern = /^[0-9]{9}$/;
  if (!sin4Pattern.test(sin4)) {
    return { isValid: false, error: "Enter 9 digit value" };
  }
  return { isValid: true, error: "" };
};

export const validateAllSearchFields = (search) => {
  const errors = {};

  const emailValidation = validateEmail(search.email);
  if (!emailValidation.isValid) errors.email = emailValidation.error;

  const mobileValidation = validateMobile(search.mobile);
  if (!mobileValidation.isValid) errors.mobile = mobileValidation.error;

  const homeValidation = validateHome(search.home);
  if (!homeValidation.isValid) errors.home = homeValidation.error;

  const sin4Validation = validateSin4(search.sin4);
  if (!sin4Validation.isValid) errors.sin4 = sin4Validation.error;

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const hasSearchCriteria = (searchParams) => {
  return !!(
    searchParams.firstName ||
    searchParams.middleName ||
    searchParams.lastName ||
    searchParams.dob ||
    searchParams.sin4 ||
    searchParams.pan ||
    searchParams.memberNumber ||
    searchParams.mobile ||
    searchParams.home ||
    searchParams.email ||
    searchParams.address ||
    searchParams.city ||
    searchParams.state ||
    searchParams.zip
  );
};
